module.exports = __webpack_public_path__ + "0d63684a8a24c892de637e11335e77dc.png";